import fetchCardBins from 'communicator/utils/api/card-bins';
import { CardBinsResponse } from 'types/api/card-bins';

type GetCardBinsPayload = CardBinsResponse | { error: unknown };

export default async function getCardBins(): Promise<GetCardBinsPayload> {
  try {
    const cardBinsResponse = await fetchCardBins();

    if (!cardBinsResponse.ok) {
      return { error: cardBinsResponse };
    }

    return cardBinsResponse.data;
  } catch (e) {
    /* istanbul ignore next */
    return { error: e };
  }
}
